export default "__VITE_ASSET__56705746__"